import { ItemUnitsRepository } from '../../domain/repositories/ItemUnitsRepository'
import { ItemUnitMiniModel } from '../models/ItemUnitMiniModel'
import { CreateUpdateItemUnitModel } from '../models/CreateUpdateItemUnitModel'
import { ItemUnitsFilterModel } from '../models/ItemUnitsFilterModel'
import type { CreateUpdateItemUnitEntity } from '../../domain/entities/CreateUpdateItemUnitEntity'
import type { ItemUnitsFilterEntity } from '../../domain/entities/ItemUnitsFilterEntity'
import type { ItemUnitEntity } from '../../domain/entities/ItemUnitsEntity'
import type { ItemUnitsResponseEntity } from '../../domain/entities/ItemUnitsResponseEntity'
import { ItemUnitsService, type PostItemUnitAdminRequest } from '@/backend/market'
import { ItemUnitModel } from '../models/ItemUnitModel'

export class ItemUnitsRepositoryImpl implements ItemUnitsRepository {
  async getItemUnits(
    filterData: ItemUnitsFilterEntity
  ): Promise<ItemUnitsResponseEntity | { error: true }> {
    try {
      const itemUnitsFilterModel = new ItemUnitsFilterModel(filterData)
      const response = await ItemUnitsService.getItemUnitsAdmin(itemUnitsFilterModel)
      const itemUnitModels =
        response.items?.map((itemUnit) => new ItemUnitMiniModel(itemUnit)) ?? []
      return {
        ...response,
        items: itemUnitModels
      }
    } catch {
      return { error: true }
    }
  }

  async getItemUnitById(id: number): Promise<ItemUnitEntity | { error: true }> {
    try {
      const response = await ItemUnitsService.getItemUnitAdmin({ id })
      const itemUnitModel = new ItemUnitModel(response)
      return itemUnitModel
    } catch {
      return { error: true }
    }
  }

  async createItemUnit(
    data: CreateUpdateItemUnitEntity
  ): Promise<{ id?: number } | { error: true }> {
    const createUpdateItemUnitModel = new CreateUpdateItemUnitModel(data)
    try {
      const response = await ItemUnitsService.postItemUnitAdmin({
        requestBody: createUpdateItemUnitModel as PostItemUnitAdminRequest
      })
      return { id: response.id }
    } catch {
      return { error: true }
    }
  }

  async updateItemUnit(
    id: number,
    data: CreateUpdateItemUnitEntity
  ): Promise<{ success: true } | { error: true }> {
    const createUpdateItemUnitModel = new CreateUpdateItemUnitModel(data)
    try {
      await ItemUnitsService.putItemUnitAdmin({
        id,
        requestBody: createUpdateItemUnitModel
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }

  async deleteItemUnit(id: number): Promise<{ success: true } | { error: true }> {
    try {
      await ItemUnitsService.deleteItemUnitAdmin({ id })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
